import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import SearchView from "../../widgets/SearchView";
import TradeSetupSearchForm from '../program/TradeSetupSearchForm';
import ViewUtils from '../../ViewUtils';
import withMenuPermission from "../../widgets/withMenuPermission";


const headCells = [
    { id: 'TradeCode', numeric: false, disablePadding: true, label: 'Artisan ID' },
    { id: 'TradeTitle', numeric: false, disablePadding: true, label: 'Artisan Title' },
    { id: 'ProgrammeStatus', numeric: false, disablePadding: true, label: 'Programme Status' },
    { id: 'CommencementDate', numeric: false, disablePadding: true, label: 'Commencement Date' },
    { id: 'CompletionDate', numeric: false, disablePadding: true, label: 'CompletionDate' },
    { id: 'TradeTestSerialNumber', numeric: false, disablePadding: true, label: 'Trade Test Serial Number' }
];


const utils = new ViewUtils();
const toolbarRef = React.createRef();

class LearnerTrade extends Component {
    constructor(props) {
        super(props);

        this.searchParameters = !utils.isNull(this.props.location.state.learnerID) ? [
            { Name: "ArtisanID", Value: "" },
            { Name: "ArtisanTitle", Value: "" },
            { Name: "ProgrammeID", Value: this.props.programmeId },
            { Name: "LearnerID", Value: this.props.location.state.learnerID }
        ]
            :
            [
                { Name: "ArtisanID", Value: "" },
                { Name: "ArtisanTitle", Value: "" },
                { Name: "LearnerID", Value: this.props.location.state.learnerID }
            ];

        let model = !utils.isNull(this.props.location.state.learnerID) ?
            {
                ArtisanID: "",
                ArtisanTitle: "",
                ProgrammeID: this.props.programmeId,
                LearnerID: this.props.location.state.learnerID

            }
            :
            {
                ArtisanID: "",
                ArtisanTitle: "",
                LearnerID: this.props.location.state.learnerID
            }


        if (!utils.isNull(props.exclusions)) {
            model.Exclusions = props.exclusions;
            this.searchParameters.push({ Name: "Exclusions", Value: props.exclusions });
        }


        this.state =
        {
            model: model,
            keyUpSwitch: false,
            selectedLearnerLearnership: null,
            clearSelectedRow: false,
            showTable: true

        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'view', label: '', tooltip: 'View', icon: 'ViewIcon', visible: this.props.menuPermissionItem.View, disabled: utils.isNull(this.state.selectedLearnerTrade) },
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', visible: this.props.menuPermissionItem.Edit, disabled: utils.isNull(this.state.selectedLearnerTrade) },
                        { id: "delete", label: "", tooltip: "Remove skills programme", icon: "DeleteIcon", visible: this.props.menuPermissionItem.Delete, disabled: utils.isNull(this.state.selectedLearnerTrade) },
                        { id: 'generate', label: 'Generate Agreement', icon: 'DownloadIcon', path: false, tooltip: 'Generate Agreement', visible: this.props.menuPermissionItem.Edit, disabled: utils.isNull(this.state.selectedLearnerTrade) },
                        { id: 'serialno', label: 'Generate Serial Number', icon: 'ExtensionIcon', path: false, tooltip: 'Generate Serial Number', visible: this.props.menuPermissionItem.Edit && !["Provider", "Agent", "AET Agent", "Employer"].includes(utils.getCurrentRole()), disabled: utils.isNull(this.state.selectedLearnerTrade) },
                        { id: 'pttr', label: 'Download PTTR', icon: 'GetAppIcon', path: false, tooltip: 'Download Pre-Trade Test Results', visible: this.props.menuPermissionItem.Edit, disabled: utils.isNull(this.state.selectedLearnerTrade) },
                        { id: 'sor', label: 'Download SOR', icon: 'AssessmentIcon', path: false, tooltip: 'Download SOR', visible: this.props.menuPermissionItem.Edit, disabled: true }
                    ]
                }
            ]
        }

        //TODO: Add url for Trade removal
        this.deleteUrl = ""
    }


    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/learner',
                state: {
                    selection: this.props.location.state.learnerID
                }
            });
        }
        else if (buttonId === "add") {
            this.props.history.push({
                pathname: '/AddLearnerTrade',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    TradeID: null,
                    hideFields: true,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem
                }
            })
        }
        else if (buttonId === "edit") {
            console.log(this.state.selectedLearnerTrade[0].Id);
            this.props.history.push({
                pathname: '/AddLearnerTrade',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    TradeID: this.state.selectedLearnerTrade[0].Id,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem,
                    viewOnly: this.state.selectedLearnerTrade[0].ProgrammeStatus === "Completed" ? true : false
                }
            })
        }
        else if (buttonId === "view") {
            this.props.history.push({
                pathname: '/AddLearnerTrade',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    TradeID: this.state.selectedLearnerTrade[0].Id,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem,
                    viewOnly: true
                }
            })
        }

        else if (buttonId === "generate") {
            this.generateDocuments();
            toolbarRef.current.setButtonDisabled("edit", true);
            toolbarRef.current.setButtonDisabled("delete", true);
            toolbarRef.current.setButtonDisabled("generate", true);
            toolbarRef.current.setButtonDisabled("serialno", true);
            toolbarRef.current.setButtonDisabled("pttr", true);
            toolbarRef.current.setButtonDisabled("sor", true);
        }

        else if (buttonId === "serialno") {
            if (!utils.isNull(this.state.selectedLearnerTrade)) {
            this.generateSerialNo();
            toolbarRef.current.setButtonDisabled("edit", true);
            toolbarRef.current.setButtonDisabled("delete", true);
            toolbarRef.current.setButtonDisabled("generate", true);
            toolbarRef.current.setButtonDisabled("serialno", true);
                toolbarRef.current.setButtonDisabled("pttr", true);
                toolbarRef.current.setButtonDisabled("sor", true);
            }
            else {
                this.setState({ selectedLearnerTrade: null, clearSelectedRow: true })
            }
        }

        else if (buttonId === "pttr") {
            if (!utils.isNull(this.state.selectedLearnerTrade)) {
                this.generatePTTR();
                toolbarRef.current.setButtonDisabled("edit", true);
                toolbarRef.current.setButtonDisabled("delete", true);
                toolbarRef.current.setButtonDisabled("generate", true);
                toolbarRef.current.setButtonDisabled("serialno", true);
                toolbarRef.current.setButtonDisabled("pttr", true);
                toolbarRef.current.setButtonDisabled("sor", true);
            }
            else {
                this.setState({ selectedLearnerTrade: null, clearSelectedRow: true })
            }
        }

        else if (buttonId === "sor") {
            if (!utils.isNull(this.state.selectedLearnerTrade)) {
                this.generateSOR();
                toolbarRef.current.setButtonDisabled("edit", true);
                toolbarRef.current.setButtonDisabled("delete", true);
                toolbarRef.current.setButtonDisabled("generate", true);
                toolbarRef.current.setButtonDisabled("serialno", true);
                toolbarRef.current.setButtonDisabled("pttr", true);
                toolbarRef.current.setButtonDisabled("sor", true);
            }
            else {
                this.setState({ selectedLearnerTrade: null, clearSelectedRow: true })
            }
        }
    }

    generateSerialNo = () => {

        let url = "api/sims/learnerTrade/GenerateSerialNumber?Id=" + this.state.selectedLearnerTrade[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            this.setState({ selectedLearnerTrade: null, clearSelectedRow: true, showTable: false }, () => {
                this.setState({ showTable: true })
            })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    generateDocuments = () => {

        let url = "api/sims/learnerTrade/GenerateLearnerAgreement?Id=" + this.state.selectedLearnerTrade[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            this.setState({ selectedLearnerTrade: null, clearSelectedRow: true })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    generatePTTR = () => {

        let url = "api/sims/learnerTrade/GeneratePTTR?Id=" + this.state.selectedLearnerTrade[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            this.setState({ selectedLearnerTrade: null, clearSelectedRow: true })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    generateSOR = () => {

        let url = "api/sims/learnerTrade/GenerateSOR?Id=" + this.state.selectedLearnerTrade[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            this.setState({ selectedLearnerTrade: null, clearSelectedRow: true })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    FileDownload = (documentName) => {

        utils.invokeUrl("api/sims/learnerTrade/DownloadLearnerAgreement?FileName=" + documentName, (response) => {

            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
        }, (e) => {
            this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
        }
        );

    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedLearnerTrade: selection })

            let url = "api/sims/LearnerTrade/CheckCanEditProgramme?Id=" + selection[0].Id;
            utils.invokeUrl(url, (response) => {
                toolbarRef.current.setButtonDisabled("edit", response.Result === "0" ? true : false)
                if (selection[0].ProgrammeStatus === "Completed" || selection[0].ProgrammeStatus === "Registered") {
                    toolbarRef.current.setButtonDisabled("delete", true)
                }
                else {
                    toolbarRef.current.setButtonDisabled("delete", false)
                }
            },
                (e) => {
                    toolbarRef.current.setButtonDisabled("edit", true)
                },
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    }
                }
            )
            if (selection[0].ProgrammeStatus === 'Completed') {
                toolbarRef.current.setButtonDisabled("sor", false)
            }
            else {
                toolbarRef.current.setButtonDisabled("sor", true)
            }
            if (utils.getCurrentRole() === "Provider" || utils.getCurrentRole() === "Agent" || utils.getCurrentRole() === "Employer" || utils.getCurrentRole() === "AET Agent") {
                toolbarRef.current.setButtonDisabled("serialno", true)
            }
            else {
                toolbarRef.current.setButtonDisabled("serialno", false)
            }
        }
        else {
            this.setState({ selectedLearnerTrade: null })
        }
    }


    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    onClearSelectedRow = () => {
        this.setState({ clearSelectedRow: false });
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {`Learner > Artisan > ${this.props.location.state.learnerNames}`}
                </p>
                {this.state.showTable === true && (
                <SearchView headCells={headCells} dataUrl={utils.isNull(this.props.dataUrl) ? "api/sims/learnerTrade/GetLearnerTradeSearch" : this.props.dataUrl}
                    deleteUrl={"api/sims/learnerTrade/unlinkLearnerTrade"} useDeletePost={true}
                    entityViewPath='/AddLearnerTrade'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    toolbarRef={toolbarRef}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="TradeProgrammeDescription" mode={this.props.mode}
                    history={this.props.history} multiSelect={this.props.multiSelect}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch}
                    setSelection={(selection) => { this.handleSelection(selection) }}
                    promptTitle={"Remove Learner Trade"}
                    promptContent={"Are you sure you want to remove the learner Trade record?"} clearSelectedRow={this.state.clearSelectedRow} onClearSelectedRow={this.onClearSelectedRow}
                >
                    <TradeSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
                )}
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(LearnerTrade));
